/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sweepsUpdateConfig } from "../../funcs/sweepsUpdateConfig.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateSweepConfigRequest$inboundSchema,
};

export const tool$sweepsUpdateConfig: ToolDefinition<typeof args> = {
  name: "sweeps-update-config",
  description: `Update settings on a sweep config.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/)
you'll need to specify the \`/accounts/{accountID}/wallets.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sweepsUpdateConfig(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
